export function replaceTextByKey (text, key, value) {
  return text.replace(key, value);
};